import { useState } from 'react'
import { Nav } from 'react-bootstrap'

import packageJson from '../../../package.json'
import contactIcon from '../../imgs/chat-3.svg'
import contactText from '../../imgs/contact-text.svg'
import fbLogo from '../../imgs/Icon-simple-facebook.svg'
import igLogo from '../../imgs/Icon-simple-instagram.svg'
// Icons
import logoWithtext from '../../imgs/logo.png'
import tiktokLogo from '../../imgs/tik-tok.png'
import ContactUs from './ContactUs'

export default function TheFooter() {
  const [isShowContactUs, setisShowContactUs] = useState(false)

  return (
    <div>
      <section style={{ backgroundColor: '#00aeef', marginTop: '160px' }}>
        <div style={{ textAlign: 'center', margin: '1rem', paddingTop: '2rem' }}>
          <a href='http://www.shiptanbul.com/'>
            <img style={{ objectFit: 'contain' }} src={logoWithtext} alt='logo' className='h-20'></img>
          </a>
        </div>
        <div
          style={{
            maxWidth: '700px',
            margin: '0 auto',
          }}
        >
          <Nav className='justify-content-center rtlText' activeKey='/home'>
            <a href='http://www.shiptanbul.com/shops' className='footerLink'>
              חנויות מומלצות
            </a>

            <a href='http://www.shiptanbul.com/about' className='footerLink'>
              אודות
            </a>

            <a href='http://www.shiptanbul.com/terms' className='footerLink'>
              תנאי שימוש
            </a>

            <a href='http://www.shiptanbul.com/privacy' className='footerLink'>
              פרטיות
            </a>

            <a href='http://www.shiptanbul.com/knowledge-center/faqs' className='footerLink'>
              שאלות נפוצות
            </a>

            <a href='http://www.shiptanbul.com/accessibility' className='footerLink'>
              הצהרת נגישות
            </a>

            <a onClick={() => setisShowContactUs(true)} className='footerLink'>
              צור קשר
            </a>
          </Nav>
        </div>

        <div className='footerSection' style={{ textAlign: 'center' }}>
          <img
            onClick={() => window.open('https://www.facebook.com/shiptanbul/')}
            style={{ margin: '1rem', cursor: 'pointer' }}
            src={fbLogo}
            alt='facebook_logo'
          />
          <img
            onClick={() => window.open('https://www.instagram.com/shiptanbul/')}
            style={{ margin: '1rem', cursor: 'pointer' }}
            src={igLogo}
            alt='instagram'
          />
          <img
            onClick={() => window.open('https://www.tiktok.com/@shiptanbul')}
            style={{ margin: '1rem', cursor: 'pointer', width: '30px' }}
            src={tiktokLogo}
            alt='tiktok'
          />
          <div className='footer-version'> Version: {packageJson.version} </div>
        </div>
      </section>
      <ContactUs show={isShowContactUs} setShow={setisShowContactUs} />
      <div className='contact-us-fixed' id='contact-us-fixed' onClick={() => setisShowContactUs(true)}>
        <img src={contactIcon} alt='contact us' />
        <img src={contactText} alt='contact us' className='contact-us-text' />
      </div>
    </div>
  )
}
